module.exports = __webpack_public_path__ + "img/keyboard-arrow-bottom.f96aad4c.svg";